import React from 'react';
import { Col, Row } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from './messages';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import Flexbox from 'flexbox-react';
import popup from '../../actions/popup';

import googlePlay from '../../assets/images/google_play_button.svg';
import appStore from '../../assets/images/app_store_button.svg';
import phones from '../../assets/images/phones.png';

/*
*
*
* add message about available apps
	const list = [
		<FormattedMessage {...messages.mobile} />
	];

	const List = ({ active }) => (
		<ul>
			{list.map((m, i) => <li className={cn(active === i && 'active')} key={i}>{m}</li>)}
		</ul>
	);
*/

export default () => {
	const handleSubmit = (e) => {
		e.preventDefault();
		popup.show(null, 'App')
	};
	return <Wrapper className='CrossPlatform'>
		<Flexbox flexDirection='column' >
			<Row>
				<Col sm={24} md={12}>
					<h2><FormattedMessage {...messages.title} /></h2>
					<p><FormattedHTMLMessage {...messages.subtitle} /></p>
				</Col>
				<Col sm={24} md={12} className='platforms'>
					<img alt="googlePlay" src={phones}/>
				</Col>
			</Row>
			<Row>
				<Col sm={24} md={12} className='storeButtons'>
					<div>
						<a href="/" onClick={handleSubmit}>
							<img alt="googlePlay" src={appStore}/>
						</a>
					</div>
					<div>
						<a href="/" onClick={handleSubmit}>
							<img alt="appStore" src={googlePlay}/>
						</a>
					</div>
					
				</Col>
			</Row>
		</Flexbox>
	</Wrapper>
};


// WEBPACK FOOTER //
// ./src/components/LandingCrossPlatform/CrossPlatform.js